import React, { Component, useEffect, useState } from 'react'

// table(components)
import filterFactory, { textFilter } from 'react-bootstrap-table2-filter';
import BoostrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';
import { PageOptions } from '../../components/PageParams';
import axios from 'axios';
import { useDispatch, useSelector } from 'react-redux';
import { setReminder } from '../../../features/UserActions';
import { HttpJsonHeader } from '../../../features/Environments';
import CustomerPopup from './CustomerPopup';
import { Button, OverlayTrigger, Tooltip  } from 'react-bootstrap';

import {AiOutlinePlus, AiFillEdit, AiOutlineDelete} from 'react-icons/ai';
import ConfirmDialog, { GetConfirmTitle } from '../../components/ConfirmDialog';
import styled from 'styled-components';

export default function Customer(props) {

    // ** UserInfo + Popup Message ***/
    const formName = "ลูกค้า/โรงพยาบาล-คลินิก";
    const userDetail = useSelector((state)=> state.user.detail)
    const dispatch = useDispatch();    
    // ** Main State ***/
    const [custEditor, setCustEditor] = useState({show:false, action:null});
    const [data, setData] = useState([]);
    const [dataX, setDataX] = useState([]);
    const [selectedRow, setSelectedRow] = useState(null);
    const [showConfirm, setShowConfirm] = useState(false); 
    const [confirmAction, setConfirmAction] = useState(null);
    const [updateFlag, setUpdateFlag]=useState(true);

    //if(winState == null) setWinState({show:false, setWinState:null});        
    useEffect(() => {        
        if(updateFlag){
           getData();     
           setUpdateFlag(false);
        }    
    }, [updateFlag]);

    
    useEffect(() => {       
        getDataX();    
    }, []);
    //----------------------------------------------------------------------  
    // ** List All rows
    const getData = async () =>{
        await axios.post(process.env.REACT_APP_API + 'api/customer/list-data', 
                { BrchId: userDetail.brchid, SearchTxt:''} ,
                HttpJsonHeader)
            .then((res)=>{                
                setData(res.data && res.data.rows);                                 
            })
            .catch(err=> 
                  dispatch(setReminder({show:true, message: err.message, type:'error'}))                   
               );
      }
      //----------------------------------------------------------------------  
      // Get component for selection on editting window
      const getDataX = async() =>{
        await axios.post(process.env.REACT_APP_API + 'api/customer/select-component', 
                { BrchId: userDetail.brchid } ,
                HttpJsonHeader)
            .then((res)=>{                
                setDataX(res.data);                                
            })
            .catch(err=> 
                dispatch(setReminder({show:true, message: err}) )
        );
      }
    //----------------------------------------------------------------------  
    // Actions
    // Save new Action 
    const openAction = () =>{
        setCustEditor({show:true, action:null});
    }
    const actionNewData = ()=>{
        setSelectedRow({
            row:{ custId:0 }, 
            action: openAction
        });                
    }  
    // Update Action
    const actionUpdate = (data) =>{
        setSelectedRow({
            row: data, 
            action: openAction
        });        
    }
    // Delete Action
    const actionDelete = (row) =>{        
        setShowConfirm(true);               
        setConfirmAction({ title: GetConfirmTitle("DELETE"), 
        data:row, 
        action:(row)=>{                 
                let dataToUpdate = {ItemInfo: row, UserInfo: userDetail};            
                axios.post(process.env.REACT_APP_API + 'api/customer/delete',                     
                    dataToUpdate, HttpJsonHeader)
                    .then((res)=>{ 
                        setUpdateFlag(true);
                        dispatch(setReminder({show:true, message: "ยกเลิกสมบูรณ์", type:"success"}) )
                     })
                    .catch(err=> { 
                        dispatch(setReminder({show:true, message: err.message, type:"error"}) ) 
                    });         
        }});  
    }
    //----------------------------------------------------------------------  
    //columns
    const getHeaderStyle = (wi)=>{
        return {
            width: wi, 
            background:'var(--table-header-back-color)'
        } 
    } 
    const customTextFilter = {      
        placeholder: "...",  
    }
    const formatEditBox = (x, row) => {
        return (
            <div>               
              <OverlayTrigger placement='top' overlay={(props)=> <Tooltip {...props}>แก้ไข</Tooltip>}> 
                <Button variant='info'  className='info-button' onClick={()=>(actionUpdate(row))} > 
                  <AiFillEdit />
                </Button> 
              </OverlayTrigger> 
    
              <OverlayTrigger placement='top' overlay={(props)=> <Tooltip {...props}>ลบ</Tooltip>}>      
                <Button variant='danger' className='info-button' onClick={()=>{actionDelete(row);}} > 
                  <AiOutlineDelete />
                </Button>
              </OverlayTrigger>         
            </div>
            )
      }
    //----------------------------------------------------------------------  
    // ** Columns List
    const columns = [
        {
            dataField:"custcode", 
            text: "รหัสลูกค้า" ,
            sort: true,
            headerStyle:()=>getHeaderStyle('120px'),      
            style:{border:'none', color:'var(--table-text-color)', textAlign:'center'},      
            filter: textFilter(customTextFilter),                  
        },
        {
            dataField:"cust_name", 
            text: "ชื่อลูกค้า" ,
            sort: true,
            headerStyle:()=>getHeaderStyle('auto'),      
            style:{border:'none', color:'var(--table-text-color)', textAlign:'left', paddingLeft:'10px'},      
            filter: textFilter(customTextFilter),                  
        },
        {
            dataField:"cust_short", 
            text: "ชื่อสั้น" ,
            sort: true,
            headerStyle:()=>getHeaderStyle('auto'),      
            style:{border:'none', color:'var(--table-text-color)', textAlign:'left', paddingLeft:'10px'},      
            filter: textFilter(customTextFilter),                  
        },
        {
            dataField:"addr", 
            text: "ทีอยู่" ,
            sort: true,
            headerStyle:()=>getHeaderStyle('auto'),      
            style:{border:'none', color:'var(--table-text-color)', textAlign:'left', paddingLeft:'10px'},      
            filter: textFilter(customTextFilter),                  
        },
        {
            dataField:"addr2", 
            text: "ทีอยู่ (ต่อ)" ,
            sort: true,
            headerStyle:()=>getHeaderStyle('auto'),      
            style:{border:'none', color:'var(--table-text-color)', textAlign:'left', paddingLeft:'10px'},      
            filter: textFilter(customTextFilter),                  
        },


        {
            dataField:"box", 
            text: "Edit" ,
            sort: true,
            headerStyle:()=>getHeaderStyle('105px'),      
            style:{border:'none', color:'var(--table-text-color)', textAlign:'center'},      
            filter: textFilter(customTextFilter),                  
            formatter: formatEditBox
        },


    ];

    //----------------------------------------------------------------------  
    return (        
        <div>  
              <HBox>
                <OverlayTrigger placement='top' overlay={(props)=> <Tooltip {...props}>เพิ่มข้อมูลใหม่</Tooltip>}> 
                    <Button variant = 'primary'  style={{margin:'5px'}}
                        onClick={()=>actionNewData()} >
                        <AiOutlinePlus/> เพิ่มข้อมูลใหม่                  
                    </Button>                   
                </OverlayTrigger>  

                <OverlayTrigger placement='top' overlay={(props)=> <Tooltip {...props}>ประเภทลูกค้า</Tooltip>}>                               
                    <Button variant = 'info'                    
                        style={{margin:'5px'}}
                        onClick={()=>actionNewData()} >
                        <AiOutlinePlus/> ประเภทลูกค้า                  
                    </Button>  
                </OverlayTrigger> 

                <div className='table-caption-box-right-flex'>
                     {formName}
                </div>    
        </HBox>
            
            <BoostrapTable
                    bootstrap4 keyField='custid' 
                    rowClasses={'table-next-rows-style'}
                    data={data}  
                    columns={columns} 
                    striped  hover condensed             
                    headerWrapperClasses = "headerWrapper" 
                    wrapperClasses="bs-table-wrapper"                                        
                    bordered={ true }       
                    pagination = {paginationFactory( PageOptions)}  
                    filter={ filterFactory() }                     
                    // selectRow = {selectRow}           
                /> 
             <CustomerPopup {...{winState:[custEditor, setCustEditor], formName, selectedRow, dataX, setDataX, setUpdateFlag}} />                           
             <ConfirmDialog {...{showConfirm, setShowConfirm, confirmAction, setConfirmAction}} /> 
       </div>
    )
}

const HBox = styled.div`
    padding: 0px; 
    display: flex;       
`;




